import { useId } from 'react';

export interface StdinEditorProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
}

/** Terminal-styled input for the stdin a paste is run with. */
export function StdinEditor({ value, onChange }: StdinEditorProps) {
  const bytes = new TextEncoder().encode(value).length;
  const counterId = useId();
  return (
    <div className="terminal-input">
      <textarea
        aria-label="Standard input"
        placeholder="Input for the program when the paste is run (optional)"
        spellCheck={false}
        aria-describedby={counterId}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <p id={counterId} className="terminal-status">
        {bytes} {bytes === 1 ? 'byte' : 'bytes'}
      </p>
    </div>
  );
}
